// Every modifier on the commonwealth, summed in one place: the tech tree,
// the government the compass names, the Hall's standing laws, and the
// wonders the town has raised, and the winter tales the campaign keeps
// (cards.js TALES). A tech, a law, a government, a wonder or a tale is
// ONE ENTRY in its table, and everything that reads a rule number reads it
// through here - `modsOf(civ).marketCoin` - never by checking an id.
//
// This lives apart from roleActions so that city.js (which prices slots and
// caps) can read it without a cycle: cards.js and hall.js import nothing
// that imports them back.

import { techMods, wonderMods, taleMods } from './cards';
import { governmentMods, lawMods } from './hall';

export const modsOf = (civ) => {
  const all = {};
  [techMods(civ), governmentMods(civ), lawMods(civ), wonderMods(civ), taleMods(civ)]
    .forEach((m) => Object.entries(m).forEach(([k, v]) => { all[k] = (all[k] || 0) + v; }));
  return new Proxy(all, { get: (t, k) => (k in t ? t[k] : 0) });
};
